export const transformCountForPluralInterval = (count: number) => {
  if (count > 21) {
    return Number(count.toString().slice(-1));
  }
  return count;
};
